import React from 'react';
import { useCookies } from '../../contexts/CookieContext';
import './CookieSettings.css';

const CookieSettings = () => {
  const { 
    cookieSettingsOpen, 
    closeCookieSettings, 
    cookiePreferences, 
    updateCookiePreference, 
    savePreferences 
  } = useCookies();
  
  if (!cookieSettingsOpen) {
    return null;
  }
  
  return (
    <div className="cookie-settings-overlay">
      <div className="cookie-settings-modal">
        <div className="settings-header">
          <h3>Configuración de cookies</h3>
          <button 
            className="close-button"
            onClick={closeCookieSettings}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>
        
        <div className="settings-content">
          <p className="settings-description">
            Puedes elegir qué tipos de cookies permites en este sitio. Las cookies esenciales 
            no pueden ser desactivadas ya que son necesarias para el funcionamiento básico.
          </p>
          
          <div className="cookie-options">
            <div className="cookie-option">
              <label className="checkbox-label">
                <input 
                  type="checkbox" 
                  checked={cookiePreferences.essential} 
                  disabled={true}
                />
                <div className="option-content">
                  <div className="option-header">
                    <span className="option-title">Cookies esenciales</span>
                    <span className="required-badge">Necesarias</span>
                  </div>
                  <p className="option-description">
                    Necesarias para el funcionamiento básico del sitio. No pueden ser desactivadas.
                  </p>
                </div>
              </label>
            </div>
            
            <div className="cookie-option">
              <label className="checkbox-label">
                <input 
                  type="checkbox" 
                  checked={cookiePreferences.analytics} 
                  onChange={() => updateCookiePreference('analytics', !cookiePreferences.analytics)}
                />
                <div className="option-content">
                  <div className="option-header">
                    <span className="option-title">Cookies analíticas</span>
                  </div>
                  <p className="option-description">
                    Nos ayudan a entender cómo utilizas el sitio para mejorar la experiencia.
                  </p>
                </div>
              </label>
            </div>
            
            <div className="cookie-option">
              <label className="checkbox-label">
                <input 
                  type="checkbox" 
                  checked={cookiePreferences.marketing} 
                  onChange={() => updateCookiePreference('marketing', !cookiePreferences.marketing)}
                />
                <div className="option-content">
                  <div className="option-header">
                    <span className="option-title">Cookies de marketing</span>
                  </div>
                  <p className="option-description">
                    Permiten mostrarte contenido personalizado y relevante para ti.
                  </p>
                </div>
              </label>
            </div>
          </div>
        </div>
        
        <div className="settings-footer">
          <button 
            className="save-settings-button"
            onClick={savePreferences}
          >
            Guardar preferencias
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieSettings;
